var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterSign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 849,
    height: 765,
    viewBox: "0 0 849 765",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M942.134 691.571L752.894 501.591L718.18 631.1L683.469 760.599L942.134 691.571Z",
    fill: "#DD1A46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M442.259 189.757L253.026 -0.224498L183.592 258.781L442.259 189.757Z",
    fill: "#003470"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M341.863 851.756L600.491 782.741L505.871 687.754L411.275 592.782L341.863 851.756Z",
    fill: "#DD1A46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M692.193 440.657L502.979 250.699L433.563 509.671L692.193 440.657Z",
    fill: "#6F3263"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M350.548 531.818L161.323 341.837L91.8974 600.845L350.548 531.818Z",
    fill: "#6F3263"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M455.06 237.762L196.428 306.78L385.635 496.736L455.06 237.762Z",
    fill: "#43376E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M363.359 579.851L104.728 648.865L199.348 743.852L293.936 838.821L363.359 579.851Z",
    fill: "#AB2B57"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M635.576 747.667L670.288 618.168L705.01 488.662L446.339 557.684L540.955 652.681L635.576 747.667Z",
    fill: "#AB2B57"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.216782 942.94L258.888 873.917L164.268 778.93L69.6512 683.934L0.216782 942.94Z",
    fill: "#DD1A46"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSign);
export default __webpack_public_path__ + "static/media/footer_sign.337002da9852a93734b916a4430fcdf8.svg";
export { ForwardRef as ReactComponent };